import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 14.75A6.75 6.75 0 1 1 14.74 8 6.76 6.76 0 0 1 8 14.75Zm0-12A5.25 5.25 0 1 0 13.24 8 5.25 5.25 0 0 0 8 2.75Zm.82 6.07a1.17 1.17 0 1 1 0-1.65 1.18 1.18 0 0 1-.01 1.65ZM6 6l-1.28 5.26L10 10l1.25-5.27Z';
const draw24px =
  'M12,21.79A9.79,9.79,0,1,1,21.79,12,9.8,9.8,0,0,1,12,21.79ZM12,3.71A8.29,8.29,0,1,0,20.29,12,8.3,8.3,0,0,0,12,3.71Zm.69,9a1,1,0,0,1-1.38-1.38,1,1,0,0,1,1.38,0A1,1,0,0,1,12.69,12.69Zm-2.52-2.52L7.08,16.92l6.75-3.09,3.09-6.75Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CompassIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'compass'),
) as IconWithRender;

CompassIcon.displayName = 'CompassIcon';
CompassIcon.propTypes = Icon.propTypes;
CompassIcon.renderIcon = (props) => <CompassIcon {...props} />;
export default CompassIcon;
